import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('companies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`companies/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('companies', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`companies/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`companies/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
